export default __webpack_public_path__ + "static/media/BearHead.e76d7a26.png";